import { ActionTree, ActionContext } from 'vuex'
import { IShoppingCartState, IRootState, IPlan, IProduct, IProductExtended } from '@/@types'
import { eventsConstants } from '@/helpers/eventsList'
import CONSTANTS from '@/constants'

const actions: ActionTree<IShoppingCartState, IRootState> = {
  addProductToShoppingCart: (
    context: ActionContext<IShoppingCartState, IRootState>,
    product: IProductExtended
  ) => {
    const newShoppingCartState = context.state.shoppingCart
    newShoppingCartState.push(product)
    context.commit('SHOPPING_CART_UPDATED', newShoppingCartState)
    const { id, name, price, merchant_id } = product
    const category = Object.values(CONSTANTS.PLANS).includes(merchant_id!) ? 'plan' : 'certificate'
    const priceParsed = price!.toString().replace('$', '')
    const products = [{ id, name, price: priceParsed, quantity: 1, category }]
    const GAObj = {
      event: eventsConstants.CHECKOUT_GA_ADD_TO_CART,
      value: {
        add: {
          currencyCode: 'USD',
          value: priceParsed,
          products,
        },
      },
    }
    context.dispatch('events/sendGAEvent', GAObj, {
      root: true,
    })
  },
  removeProductFromShoppingCart: (
    context: ActionContext<IShoppingCartState, IRootState>,
    product: IProductExtended
  ) => {
    if (product.addOnChecked) {
      product.addOnChecked = false
    }
    context.commit(
      'SHOPPING_CART_UPDATED',
      context.state.shoppingCart.filter(item => {
        // item is NOT PLANS.SKILL_DIVE_ANNUAL
        // go for regular filtering
        if (item.merchant_id !== CONSTANTS.PLANS.SKILL_DIVE_ANNUAL) {
          return item.merchant_id !== product.merchant_id
        }
        // item is PLANS.SKILL_DIVE_ANNUAL
        // check if there are *NO* Skill Dive AddOns checked to filter the plan
        if (item.addOnsOnCart?.length === 0) {
          return item.merchant_id !== product.merchant_id
        }
        // if there are Skill Dive AddOns checked do not filter the plan
        return true
      })
    )
    const { id, name, price, merchant_id } = product
    const category = Object.values(CONSTANTS.PLANS).includes(merchant_id!) ? 'plan' : 'certificate'
    const priceParsed = price!.toString().replace('$', '')
    const products = [{ id, name, price: priceParsed, quantity: 1, category }]
    const GAObj = {
      event: eventsConstants.CHECKOUT_GA_REMOVE_FROM_CART,
      value: {
        remove: {
          currencyCode: 'USD',
          value: priceParsed,
          products,
        },
      },
    }
    context.dispatch('events/sendGAEvent', GAObj, {
      root: true,
    })
  },
  updateCoupon: (context: ActionContext<IShoppingCartState, IRootState>, payload) => {
    context.commit('COUPON_UPDATED', payload)
  },
}

export default actions
